module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/trouble_img_02-68c09f58a7fefa97e5e2637f17d50221.jpg";